module.exports = __webpack_public_path__ + "img/template0.80198ba9.jpg";